export default __webpack_public_path__ + "static/media/industry_image.9fce28ea.svg";